/** Testimonios de practicantes Gestalt. */
export type Voice = {
  quote: string
  name: string
  role: string
  location: string
}

export const voices: Voice[] = [
  {
    quote:
      'I sometimes had an idea for an experiment but struggled to find a natural way to introduce it. Having sample invitation language and closing questions gives me a clearer starting point without making the session feel scripted.',
    name: 'Ethan R.',
    role: 'Gestalt Psychotherapist',
    location: 'San Francisco, California, United States',
  },
  {
    quote:
      'The chair-work section helps me think through different ways to introduce dialogue work. I especially like having options to lower the intensity when a client seems hesitant.',
    name: 'Chloe B.',
    role: 'Gestalt Therapy Practitioner',
    location: 'Austin, Texas, United States',
  },
  {
    quote:
      'Planning a group session can mean balancing several people and different levels of participation. The group-session outlines give me a structure to adapt while leaving room for what emerges in the room.',
    name: 'Sophia K.',
    role: 'Gestalt Therapist & Group Facilitator',
    location: 'Chicago, Illinois, United States',
  },
  {
    quote:
      'I understand the concepts in theory, but choosing how to work with a moment in session can feel less straightforward. The Notice, Name, Grade, Offer, Assimilate sequence gives me a useful framework to reflect on.',
    name: 'Amelia C.',
    role: 'Gestalt Psychotherapist',
    location: 'London, United Kingdom',
  },
]
